<template>
  <div class="issuu touch" @click.stop="$store.commit('actions/SET_ISSUU_URL', '')">
    <div class="issuu__inner">
      <div class="issuu__control-overlay"></div>
      <div style="position:relative;padding-top:max(50%,326px);height:0;width:100%;" @click.stop="">
        <iframe sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox" allowfullscreen="true" style="position:absolute;border:none;width:100%;height:100%;left:0;right:0;top:0;bottom:0;" :src="url"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['url'],

  watch: {
    $route () {
      this.$store.commit('actions/SET_ISSUU_URL', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.issuu {
  background: rgba(0, 0, 0, .7);
  bottom: 10rem;
  display: flex;    
  left: 0;
  position: absolute;
  right: 32.5rem;
  top: 0;
  // width: 100%;
  z-index: 200;

  &__inner {
    margin: auto 0 0;
    padding: 10rem;
    width: 100%;
  }

  &__control-overlay {
    background: #1e1e1e;
    bottom: 10rem;
    height: 45px;
    left: 10rem;
    position: absolute;
    right: 10rem;
    overflow: hidden;
    z-index: 10;

    &::before {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABaCAQAAADTVfQ2AAAAPUlEQVR4AU2MAQoAIBDCzuv+/+YQERZDtqDGRztT4hTmwgWS24xMpWseXM7eZyHMQ4bLP3WIObxdOFdIJT+cCQFTpiGPbAAAAABJRU5ErkJggg==);
      background-repeat: repeat-x;
      content: '';
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      height: 89px;
      pointer-events: all;
    }
  }
}
</style>